import { useEffect } from 'react';
import DeliveryLiveMap from './DeliveryLiveMap';

interface DeliveryMapModalProps {
  open: boolean;
  onClose: () => void;
  initialStatus?: 'All' | 'Active' | 'Out for Delivery' | 'Pending' | 'Delivered';
  initialDriver?: string;
  initialFromDate?: string;
  initialToDate?: string;
}

export default function DeliveryMapModal({
  open,
  onClose,
  initialStatus,
  initialDriver,
  initialFromDate,
  initialToDate,
}: DeliveryMapModalProps) {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (open) {
      window.addEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-3 sm:p-6 bg-slate-900/40 backdrop-blur-xs animate-fadeIn">
      <div className="w-full max-w-6xl h-[88vh] max-h-[850px] flex flex-col shadow-2xl rounded-2xl overflow-hidden">
        <DeliveryLiveMap
          onClose={onClose}
          isModal
          initialStatus={initialStatus}
          initialDriver={initialDriver}
          initialFromDate={initialFromDate}
          initialToDate={initialToDate}
        />
      </div>
    </div>
  );
}
